import TableRepeater from './table-repeater';

export default TableRepeater;
